import React, { useCallback, useMemo } from 'react';
import { Grid } from '@mui/material';
import moment from 'moment';
import DatePickerSmall from '../components/datePicker';

const DueDateSection = ({
  open,
  setDueDate,
  updateCardmutate,
  // data,
  reporter,
  due_date,
  card_id,
  checkBoardOwnerOrAdmin,
  currentUserId,
  boardPermission,
  assigned_to_user_id
}) => {
    // Memoize permission check
    const hasEditPermission = useMemo(() => 
      checkBoardOwnerOrAdmin || reporter == currentUserId() || 
      (boardPermission?.can_edit_task && assigned_to_user_id == currentUserId()),
      [checkBoardOwnerOrAdmin, reporter, currentUserId,boardPermission]
    );

  // Memoize handlers
  const handleDueDateKeyDown = useCallback((newDate) => {
    updateCardmutate({
      card_id: card_id,
      data: {
        due_date: newDate ? moment(newDate).format("YYYY-MM-DD") : 0,
      },
    });
    setDueDate(false);
  }, [card_id, updateCardmutate, setDueDate]);

  const handleDuedateBlur = useCallback((event) => {
    setDueDate(event);
  }, [setDueDate]);

  const handleDueDate = useCallback(() => {
    if (hasEditPermission) {
      setDueDate(true);
    }
  }, [hasEditPermission, setDueDate]);

  return (
    <div className="box">
      <Grid item className="allocated-hours">
        <p>Due Date</p>
        <div className="taskdetail-sidebar-right-col">
          {open ? (
            <DatePickerSmall
              date={due_date}
              handleDueDateKeyDown={handleDueDateKeyDown}
              handleDuedateBlur={handleDuedateBlur}
            />
          ) : (
            <div className="due-date" onClick={handleDueDate}>
              <div className="due-date-input">
                {due_date ? (
                  moment.utc(due_date).local().format("MM/DD/YYYY")
                ) : (
                  <p className="due-date-input-none">None</p>
                )}
              </div>
            </div>
          )}
        </div>
      </Grid>
    </div>
  );
};

export default React.memo(DueDateSection);